import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import classNames from "classnames";
import dayjs from "dayjs";

import { CCard, CCardBody } from "@coreui/react";

import { comboApi } from "src/1/apis/combo.api";
import { comboItemApi } from "src/1/apis/combo_item.api";
import { CTable } from "src/1/common/components/others";
import { CCheckbox, CInput, CTextarea } from "src/common/components/controls";
import { WEEKDAYS_OPTIONS } from "src/modules/menu/constants";

const ChiTietDeXuatCombo = () => {
  //#region Data
  const params = useParams();

  const [selectedComboItem, setSelectedComboItem] = useState("");

  const { data, isFetching } = useQuery({
    queryKey: ["chi-tiet-de-xuat-combo", params?.id],
    queryFn: () => comboApi.getProposalById(params.id),
    enabled: Boolean(params.id),
    select: (response) => response?.data?.data,
  });

  useEffect(() => {
    if (data && data.items && data.items.length > 0) {
      setSelectedComboItem(data.items[0].id);
    }
  }, [data]);

  const { data: items = [], isFetching: isItemsFetching } = useQuery({
    queryKey: ["chi-tiet-mat-hang-trong-combo-item", selectedComboItem],
    queryFn: () => comboItemApi.getById(selectedComboItem),
    enabled: Boolean(selectedComboItem),
    select: (response) => response?.data?.data?.goods,
    staleTime: 0,
    cacheTime: 0,
  });
  //#endregion

  //#region Event
  const handleRowClick = (row) => {
    setSelectedComboItem(row?.id);
  };
  //#endregion

  //#region Render
  const comboItemHeaders = [
    {
      key: "code",
      label: "Mã combo item",
      align: "left",
      cellRender: (v, record) => (
        <span
          className={classNames(
            "cursor-pointer block",
            selectedComboItem === record?.id && "text-[#0c35e1] font-medium",
          )}
        >
          {v}
        </span>
      ),
    },
    {
      key: "name",
      label: "Tên combo item",
      align: "left",
      cellRender: (v, record) => (
        <span
          className={classNames(
            "cursor-pointer block",
            selectedComboItem === record?.id && "text-[#0c35e1] font-medium",
          )}
        >
          {v}
        </span>
      ),
    },
    {
      key: "quantity",
      label: "Số lượng",
    },
    {
      key: "unit",
      label: "Đơn vị tính",
    },
  ];
  const itemHeaders = [
    {
      key: "code",
      label: "Mã mặt hàng",
      align: "left",
    },
    {
      key: "name",
      label: "Tên mặt hàng",
      align: "left",
    },
    {
      key: "unit",
      label: "Đơn vị tính",
    },
  ];
  const storesHeaders = [
    {
      key: "name",
      label: "Tên chi nhánh",
      align: "left",
    },
    {
      key: "price",
      label: "Giá",
      align: "right",
      columnType: "number",
    },
    {
      key: "from",
      label: "Từ",
      columnType: "option",
      options: WEEKDAYS_OPTIONS,
    },
    {
      key: "to",
      label: "Đến",
      columnType: "option",
      options: WEEKDAYS_OPTIONS,
    },
    {
      key: "holiday",
      label: "Áp dụng lễ",
      cellRender: (value) => (
        <div className="flex items-center justify-center">
          <CCheckbox value={value} readOnly />
        </div>
      ),
    },
  ];
  return (
    <div className="flex flex-col gap-4">
      <CCard>
        <CCardBody>
          <p className="text-lg font-semibold">
            Thông tin chi tiết đề xuất Combo
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
            <div className="lg:col-span-2 grid grid-cols-1 lg:grid-cols-2 gap-2">
              <CInput label="Mã Combo" value={data?.code} disabled />
              <CInput label="Tên Combo" value={data?.name} disabled />
              <CInput
                label="Áp dụng từ ngày"
                value={data?.from ? dayjs(data.from).format("DD/MM/YYYY") : ""}
                disabled
              />
              <CInput
                label="Đến ngày"
                value={data?.to ? dayjs(data.to).format("DD/MM/YYYY") : ""}
                disabled
              />
              <CTextarea label="Ghi chú" value={data?.note} disabled />
            </div>
            <div>
              <img src={data?.file?.path} alt="" />
            </div>
          </div>
        </CCardBody>
      </CCard>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <CCard>
          <CCardBody>
            <p className="text-lg font-semibold">Danh sách Combo item</p>
            <CTable
              loading={isFetching}
              headers={comboItemHeaders}
              data={data?.items ?? []}
              fontSizeBody={16}
              divider
              onRowClick={handleRowClick}
            />

            <p className="font-semibold m-0 mt-4 text-base">
              Tổng cost từ combo item:&nbsp;
              <span className="text-[#0c35e1]">
                {(data?.cost ?? 0)?.toLocaleString("en-US")}
                &nbsp; VNĐ
              </span>
            </p>
          </CCardBody>
        </CCard>
        <CCard>
          <CCardBody>
            <p className="text-lg font-semibold">
              Các mặt hàng trong Combo Item:&nbsp;
              {data?.items?.find((e) => e.id === selectedComboItem)?.name}
            </p>
            <CTable
              loading={isItemsFetching}
              headers={itemHeaders}
              data={items ?? []}
              fontSizeBody={16}
              divider
              height={460}
            />
          </CCardBody>
        </CCard>
      </div>
      <CCard>
        <CCardBody>
          <p className="text-lg font-semibold">
            Chi tiết giá bán tại chi nhánh
          </p>
          <CTable
            headers={storesHeaders}
            data={data?.stores ?? []}
            fontSizeBody={16}
            divider
            height={400}
          />
        </CCardBody>
      </CCard>
    </div>
  );
  //#endregion
};
export default ChiTietDeXuatCombo;
